// 设置用户登录信息
export const SET_USER_LOGIN_INFO = (state, data) => {
  state.userInfo = data
}

// 设置用户登录信息
export const SET_TRIALACCOUNT = (state, data) => {
  state.TrialAccount = data
}

export const SET_USER_SIGNOUT = (state) => {
  state.userInfo = {}
}

export const SET_TASKMD5LIST = (state, data) => {
  state.taskMD5List = data
}

export const SET_SYSTEMLIST = (state, data) => {
  state.SystemList = data
}

export const SET_HISTORYBYPERSON = (state, data) => {
  state.historybyperson = data
}

export const SET_MODULESYSTEMN = (state, data) => {
  state.moduleSystem = data
}

export const PUSH_TASKMD5lIST = (state, date) => {
  const time = new Date().format("yyyy-MM-dd hh:mm:ss")
  state.taskMD5List.push({
    start_time: time,
    md5: date,
    isDownload: false
  })
}

export const SET_ISDOWNLOAD = (state,data) => {
  let temp = state.taskMD5List
  for (let i = 0; i < temp.length; i++) {
    if(temp[i].md5 === data) {
      temp[i].isDownload = true
      break;
    }
  }
}

